<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="
                    stockAdjustment.id
                      ? true
                      : false || this.isBackDateDataEntry != 'ACTIVE'
                  "
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockAdjustment.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="stockAdjustment.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex :class="stockAdjustment.id ? 'sm6' : 'sm12'">
                <v-text-field
                  name="serialNo"
                  label="Serial No."
                  v-model="stockAdjustment.serialNo"
                  type="text"
                  :rules="rules.serialNoRules(255, 'Serial No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="user.role.roleName == 'ADMIN'">
                <v-autocomplete
                  v-model="stockAdjustment.warehouseName"
                  :items="activeWarehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="name"
                  :readonly="stockAdjustment.id ? true : false"
                  @change="showBins()"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                sm6
                v-if="
                  user.role.roleName == 'WAREHOUSE_MANAGER' ||
                    user.role.roleName == 'WAREHOUSE_STAFF' ||
                    user.role.roleName == 'PRODUCTION_MANAGER' ||
                    user.role.roleName == 'ASSET_MANAGER' ||
                    user.role.roleName == 'BRANCH_ADMIN'
                "
              >
                <v-text-field
                  label="Warehouse Name"
                  v-model="warehouseName"
                  type="text"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="stockAdjustment.binId"
                  :items="binList"
                  color="blue-grey lighten-2"
                  label="Choose Bin..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="stockAdjustment.id ? true : false"
                  :rules="rules.binRules"
                  @change="changeBin()"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="stockAdjustment.status"
                  :items="stockAdjustmentTypeList"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  menu-props="auto"
                  item-value="value"
                  :readonly="stockAdjustment.id ? true : false"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockAdjustment.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                  :readonly="stockAdjustment.id ? true : false"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockAdjustment.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockAdjustment.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockAdjustment.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockAdjustment.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockAdjustment.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockAdjustment.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addStockAdjustmentItem()"
                    :disabled="stockAdjustment.id ? true : false"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs10 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="stockAdjustment.id ? true : false"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs4>Product</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs2>Qty</v-flex>
                  <v-flex xs3>QC No</v-flex>
                  <v-flex xs2>Batch No</v-flex>
                  <v-flex xs3 class="text-xs-center">MFG Date</v-flex>
                  <v-flex xs3 class="text-xs-center">EXP Date</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  v-for="(stockAdjustmentItem,
                  index) in stockAdjustment.stockAdjustmentItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      v-if="stockAdjustment.id ? true : false"
                      placeholder="Select the code"
                      v-model="stockAdjustmentItem.productCode"
                      readonly
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="stockAdjustmentItem.productCode"
                      @click="showProducts(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="stockAdjustmentItem.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockAdjustmentItem.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="stockAdjustmentItem.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      :readonly="stockAdjustment.id ? true : false"
                      label="Select"
                      @change="(option) => changeFactorUnit(option, index)"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockAdjustmentItem.qty"
                      min="0"
                      :rules="rules.qtyRules"
                      :readonly="stockAdjustment.id ? true : false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="stockAdjustmentItem.qcNo"
                      :items="stockAdjustmentItem.stockQcNoDTOList"
                      item-text="qcNo"
                      item-value="qcNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :hide-no-data="true"
                      :readonly="stockAdjustment.id ? true : false"
                      @change="getQcBatchNoList(stockAdjustmentItem)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockAdjustmentItem.batchNo"
                      :items="stockAdjustmentItem.batchNoList"
                      item-text="batchNo"
                      item-value="batchNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :hide-no-data="true"
                      :readonly="stockAdjustment.id ? true : false"
                      @change="getBatchDate(stockAdjustmentItem)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="stockAdjustment.id ? true : false"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="MFG Date"
                        type="text"
                        prepend-icon="event"
                        v-model="stockAdjustmentItem.mfgDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="stockAdjustmentItem.mfgDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="stockAdjustment.id ? true : false"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="EXP Date"
                        type="text"
                        prepend-icon="event"
                        v-model="stockAdjustmentItem.expDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="stockAdjustmentItem.expDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockAdjustmentItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="stockAdjustment.id ? true : false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 v-if="stockAdjustment.id">
                    <v-btn
                      class="mx-0"
                      icon
                      @click="
                        removeStockAdjustmentItem(index, stockAdjustment.id)
                      "
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 v-else>
                    <v-btn
                      class="mx-0"
                      icon
                      v-if="index === 0"
                      @click="
                        removeStockAdjustmentItem(index, stockAdjustment.id)
                      "
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-0"
                      icon
                      v-else
                      @click="
                        removeStockAdjustmentItem(index, stockAdjustment.id)
                      "
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="stockAdjustment.id ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    @click="onSave"
                    :disabled="btnDisabled || saveLoading"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = !messageDialogBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            flat
            @click="messageDialogBox = !messageDialogBox"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ProductListDialog
      :showDialog="showProductListDialog"
      :params="{ isPurchase: true }"
      @close="closeProductDialog"
    ></ProductListDialog>
  </v-container>
</template>
<script>
import { warehouseService } from "../../services/warehouse-service";
import { productService } from "../../services/product-service";
import { commonService } from "../../services/common-service";
import { StockAdjustmentFormRules } from "../../helpers/validation-rules";
import { StockAdjustment, StockAdjustmentItem } from "../../models/model";
import { stockAdjustmentService } from "../../services/stock-adjustment-service";
import { stockService } from "../../services/stock-service";
import ProductListDialog from "../dialogs/ProductListDialog.vue";

export default {
  name: "StockAdjustmentDetail",
  components: { ProductListDialog },

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    isBackDateDataEntry: JSON.parse(
      localStorage.getItem("BACKDATE_DATA_ENTRY")
    ),
    valid: true,
    breadcrumbs: [
      {
        text: "Stock Adjustment",
        disabled: false,
        to: "stock-adjustments",
      },
      {
        text: "Stock Adjustment Detail",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    issueDate: "",
    warehouseName: "",
    stockAdjustment: new StockAdjustment(),
    oldStockAdjustment: new StockAdjustment(),
    stockAdjustmentItem: new StockAdjustmentItem(),
    activeWarehouseList: [],
    tempList: [],
    binList: [],
    rules: new StockAdjustmentFormRules(),
    responseError: "",
    btnDisabled: false,
    saveLoading: false,
    showAutocompleteLoading: false,
    stockAdjustmentTypeList: [
      { label: "DAMAGE", value: "DAMAGE" },
      { label: "LOSS", value: "LOSS" },
      { label: "RE_FOUNDED", value: "RE_FOUNDED" },
    ],
    showProductListDialog: false,

    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0,
    messageDialogBox: false,
    scanBarcode: "",
  }),

  created() {
    if (this.user.role.roleName == "ADMIN") {
      this.getActiveWarehouseList();
    } else if (
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.warehouseName = this.user.warehouseName;
      this.stockAdjustment.warehouseName = this.user.warehouseName;
      this.stockAdjustment.warehouseId = this.user.warehouseId;
      let warehouseId = this.user.warehouse.id;
      if (this.user.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      } else {
        this.getWarehouseDetail(warehouseId);
      }
    } else if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.warehouseName = this.user.shop.warehouseName;
      this.stockAdjustment.warehouseName = this.user.shop.warehouseName;
      this.stockAdjustment.warehouseId = this.user.shop.warehouseId;
      let warehouseId = this.user.shop.warehouseId;
      this.getWarehouseDetail(warehouseId);
    }

    const id = this.$route.params.id;
    if (id == "new") {
      // new stockin
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.addStockAdjustmentItem();
    } else {
      this.getStockAdjustmentDetail(id);
    }
  },

  methods: {
    getWarehouseDetail(id) {
      warehouseService.getWarehouseDetail(id).then((res) => {
        this.binList = res.data.binList;
      });
    },

    showBins() {
      let warehouseName = this.stockAdjustment.warehouseName;
      let warehouse = commonService.search(
        "name",
        warehouseName,
        this.activeWarehouseList
      );
      this.binList = warehouse.binList;
      this.stockAdjustment.warehouseId = warehouse.id;
      this.stockAdjustment.stockAdjustmentItems = [];
      this.addStockAdjustmentItem();
    },

    changeBin() {
      this.stockAdjustment.stockAdjustmentItems = [];
      this.addStockAdjustmentItem();
    },

    getWarehouseList() {
      var temp;
      var tempWarehouseList = [];
      temp = this.stockAdjustment.warehouse.name;
      if (!this.tempList.includes(temp)) {
        this.tempList.push(temp);
        tempWarehouseList.push(this.stockAdjustment.warehouse);
      }

      for (var j = 0; j < this.activeWarehouseList.length; j++) {
        temp = this.activeWarehouseList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempWarehouseList.push(this.activeWarehouseList[j]);
        }
      }
      this.activeWarehouseList = tempWarehouseList;
    },

    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          let tempList = res.data;
          for (let temp of tempList) {
            this.activeWarehouseList.push(temp);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getStockAdjustmentDetail(id) {
      stockAdjustmentService
        .getStockAdjustmentDetail(id)
        .then((res) => {
          this.stockAdjustment = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockAdjustment.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockAdjustment.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.btnDisabled = true;
          this.issueDate = commonService.millisecondToDate(
            this.stockAdjustment.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          if (this.user.roleName == "WAREHOUSE_STAFF") {
            this.binList = this.user.selectedBinList;
            let bin = this.binList.forEach((v) => v.id == res.data.binId);
            if (typeof bin == "undefined") {
              this.binList.push(res.data.bin);
            }
          } else {
            this.binList = res.data.warehouse.binList;
          }

          this.stockAdjustment.stockAdjustmentItems.forEach((stAdjItem) => {
            if (stAdjItem.mfgDateInMilliSeconds) {
              stAdjItem.mfgDate = commonService.millisecondToDate(
                stAdjItem.mfgDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            }
            if (stAdjItem.expDateInMilliSeconds) {
              stAdjItem.expDate = commonService.millisecondToDate(
                stAdjItem.expDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            }
          });

          // deep copy
          this.oldStockAdjustment = JSON.parse(JSON.stringify(res.data));
          this.getWarehouseList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          //convert to millisecond
          this.stockAdjustment.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );

          this.stockAdjustment.stockAdjustmentItems.forEach((stAdjItem) => {
            if (stAdjItem.mfgDate) {
              stAdjItem.mfgDateInMilliSeconds = commonService.convertToMilliseconds(
                stAdjItem.mfgDate
              );
            }
            if (stAdjItem.expDate) {
              stAdjItem.expDateInMilliSeconds = commonService.convertToMilliseconds(
                stAdjItem.expDate
              );
            }
          });

          this.stockAdjustment.isBackDateDataEntry = this.isBackDateDataEntry;
          stockAdjustmentService
            .saveStockAdjustment(this.stockAdjustment)
            .then((res) => {
              if (res) {
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    addStockAdjustmentItem() {
      // deep copy
      stockAdjustmentItem = new StockAdjustmentItem();
      let stockAdjustmentItem = JSON.parse(
        JSON.stringify(this.stockAdjustmentItem)
      );
      this.stockAdjustment.stockAdjustmentItems.push(stockAdjustmentItem);
    },

    removeStockAdjustmentItem(index, stockAdjustmentItemId) {
      if (stockAdjustmentItemId) {
        // add delete stock in id
        if (!this.stockAdjustment.deleteStockAdjustmentItemIds) {
          this.stockAdjustment.deleteStockAdjustmentItemIds = [];
        }
        this.stockAdjustment.deleteStockAdjustmentItemIds.push(
          stockAdjustmentItemId
        );
      }
      this.$delete(this.stockAdjustment.stockAdjustmentItems, index);
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockAdjustment.id) {
        this.stockAdjustment = new StockAdjustment();
        this.addStockAdjustmentItem();
      } else {
        this.stockAdjustment = Object.assign({}, this.oldStockAdjustment);
      }
    },

    showProducts() {
      if (this.stockAdjustment.warehouseId && this.stockAdjustment.binId) {
        this.showProductListDialog = true;
      } else {
        this.messageDialogBox = true;
        if (!this.stockAdjustment.warehouseId) {
          this.responseError = "Please select warehouse first.";
        } else if (!this.stockAdjustment.binId) {
          this.responseError = "Please select bin first.";
        }
      }
    },

    closeProductDialog(product) {
      this.showProductListDialog = false;
      if (product && product.id) {
        let stAdjItem = this.stockAdjustment.stockAdjustmentItems[
          this.selectedIndex
        ];
        stAdjItem.productId = product.id;
        stAdjItem.productCode = product.code;
        stAdjItem.productName = product.name;
        // set default unit
        var j = "";
        for (var i = 0; i < product.productUnits.length; i++) {
          if (product.productUnits[i].basicUnit == true) j = i;
        }
        stAdjItem.productUnitId = product.productUnits[j].id;
        stAdjItem.factorUnitName = product.productUnits[j].factorUnitName;
        stAdjItem.productUnits = product.productUnits;
        this.getProductQcBatchDateList(stAdjItem);
        stAdjItem.unitCost = 0;
        stAdjItem.sellingPrice = 0;
        this.clearQCno(stAdjItem);
      }
    },
    getProductQcBatchDateList(stockAdjustmentItem) {
      stockAdjustmentItem.qcNo = "";
      stockAdjustmentItem.batchNo = "";
      stockAdjustmentItem.mfgDate = "";
      stockAdjustmentItem.expDate = "";
      let params = {
        warehouseId: this.stockAdjustment.warehouseId,
        binId: this.stockAdjustment.binId,
        productId: stockAdjustmentItem.productId,
        balanceType: "",
      };
      return stockService
        .getStockQcBatchDateList(params)
        .then((res) => {
          stockAdjustmentItem.stockQcNoDTOList = res.data;
          this.getQcBatchNoList(stockAdjustmentItem);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQcBatchNoList(stockAdjustmentItem) {
      stockAdjustmentItem.batchNo = "";
      stockAdjustmentItem.mfgDate = "";
      stockAdjustmentItem.expDate = "";
      let qc = stockAdjustmentItem.stockQcNoDTOList.find(
        (v) => v.qcNo == stockAdjustmentItem.qcNo
      );
      if (qc) {
        stockAdjustmentItem.batchNoList = qc.batchNoList;
        this.getBatchDate(stockAdjustmentItem);
      }
    },
    getBatchDate(stockAdjustmentItem) {
      stockAdjustmentItem.mfgDate = "";
      stockAdjustmentItem.expDate = "";
      let batchNo = stockAdjustmentItem.batchNoList.find(
        (v) => v.batchNo == stockAdjustmentItem.batchNo
      );
      if (batchNo) {
        let batchDate = batchNo.qcBatchDateDTOList.find(
          (v) => v.batchNo == stockAdjustmentItem.batchNo
        );
        if (batchDate) {
          stockAdjustmentItem.mfgDate = batchDate.mfgDate;
          stockAdjustmentItem.expDate = batchDate.expDate;
        }
      }
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            this.setProductByBarcode(productUnit);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },

    setProductByBarcode(productUnit) {
      if (this.stockAdjustment.stockAdjustmentItems[0].productCode == "") {
        this.addValuesToFirstStockAdjustmentItem(productUnit);
      } else if (this.isItemExist(productUnit)) {
        this.addQtyToExistingStockAdjustmentItem(productUnit);
      } else {
        this.addNewItemToStockAdjustmentItemList(productUnit);
      }
    },
    addQtyToExistingStockAdjustmentItem(productUnit) {
      this.stockAdjustment.stockAdjustmentItems.forEach((item) => {
        if (item.productUnitId === productUnit.id) {
          item.qty = Math.abs(item.qty) + 1;
        }
      });
    },
    isItemExist(productUnit) {
      for (let item of this.stockAdjustment.stockAdjustmentItems) {
        if (item.productUnitId === productUnit.id) {
          return true;
        }
      }
    },
    addValuesToFirstStockAdjustmentItem(productUnit) {
      this.stockAdjustment.stockAdjustmentItems[0].productId =
        productUnit.product.id;
      this.stockAdjustment.stockAdjustmentItems[0].productCode =
        productUnit.product.code;
      this.stockAdjustment.stockAdjustmentItems[0].productName =
        productUnit.product.name;
      this.stockAdjustment.stockAdjustmentItems[0].productUnitId =
        productUnit.id;
      this.stockAdjustment.stockAdjustmentItems[0].productUnits.push(
        productUnit
      );
      this.stockAdjustment.stockAdjustmentItems[0].factorUnitName =
        productUnit.factorUnitName;
      this.stockAdjustment.stockAdjustmentItems[0].qty = 1;
      this.stockAdjustment.stockAdjustmentItems[0].unitCost = 0;
      this.stockAdjustment.stockAdjustmentItems[0].sellingPrice = 0;
    },
    addNewItemToStockAdjustmentItemList(productUnit) {
      let stockAdjustmentItem = JSON.parse(
        JSON.stringify(this.stockAdjustmentItem)
      );
      stockAdjustmentItem.productId = productUnit.product.id;
      stockAdjustmentItem.productCode = productUnit.product.code;
      stockAdjustmentItem.productName = productUnit.product.name;
      stockAdjustmentItem.productUnitId = productUnit.id;
      stockAdjustmentItem.productUnits[0] = productUnit;
      stockAdjustmentItem.factorUnitName = productUnit.factorUnitName;
      stockAdjustmentItem.qty = 1;
      stockAdjustmentItem.unitCost = 0;
      stockAdjustmentItem.sellingPrice = 0;

      this.stockAdjustment.stockAdjustmentItems.push(stockAdjustmentItem);
    },
    changeFactorUnit(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.stockAdjustment.stockAdjustmentItems[index].productUnits
      );
      if (this.checkItemDuplicate(productUnit, index)) {
        let item = productUnit.product.name + " (" + factorUnitName + ")";
        this.responseError =
          "Stock Adjustment Item: " + item + " is duplicated";
        this.messageDialogBox = true;
      }
      this.stockAdjustment.stockAdjustmentItems[index].productUnitId =
        productUnit.id;
    },
    checkItemDuplicate(productUnit, index) {
      for (let item in this.stockAdjustment.stockAdjustmentItems) {
        if (item != index) {
          if (
            this.stockAdjustment.stockAdjustmentItems[item].productUnitId ===
            productUnit.id
          ) {
            return true;
          }
        }
      }
    },
    clearQCno(stockAdjustmentItem) {
      stockAdjustmentItem.qcNo = "";
      stockAdjustmentItem.batchNo = "";
      stockAdjustmentItem.mfgDate = "";
      stockAdjustmentItem.mfgDateInMilliSeconds = "";
      stockAdjustmentItem.expDate = "";
      stockAdjustmentItem.expDateInMilliSeconds = "";
    },
  },
};
</script>
